class DualTilesSlideshow {
  constructor(element) {
    this.slideshow = element;
    this.slides = this.slideshow.querySelectorAll('.slideshow__slide');
    this.currentIndex = 0;
    this.autoplaySpeed = parseInt(this.slideshow.dataset.autoplaySpeed) * 1000 || 4000;
    this.autoplayTimer = null;

    this.#init();
  }

  #init() {
    if (this.slides.length <= 1) {
      return;
    }

    this.#startAutoplay();
  }

  #goToSlide(index) {
    this.slides[this.currentIndex].classList.remove('active');

    this.currentIndex = index;

    this.slides[this.currentIndex].classList.add('active');
  }

  #nextSlide() {
    const nextIndex = (this.currentIndex + 1) % this.slides.length;
    this.#goToSlide(nextIndex);
  }

  #startAutoplay() {
    this.#clearAutoplay();
    this.autoplayTimer = setInterval(() => {
      this.#nextSlide();
    }, this.autoplaySpeed);
  }

  #clearAutoplay() {
    if (this.autoplayTimer) {
      clearInterval(this.autoplayTimer);
      this.autoplayTimer = null;
    }
  }

  destroy() {
    this.#clearAutoplay();
  }
}

const initDualTilesSlideshows = () => {
  const slideshows = document.querySelectorAll('[data-slideshow]');
  const instances = new Map();

  for (const slideshow of slideshows) {
    const blockId = slideshow.dataset.blockId;
    if (!instances.has(blockId)) {
      const instance = new DualTilesSlideshow(slideshow);
      instances.set(blockId, instance);
    }
  }

  return instances;
};

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', initDualTilesSlideshows);
} else {
  initDualTilesSlideshows();
}

if (Shopify?.designMode) {
  document.addEventListener('shopify:section:load', (event) => {
    const slideshows = event.target.querySelectorAll('[data-slideshow]');
    for (const slideshow of slideshows) {
      new DualTilesSlideshow(slideshow);
    }
  });

  document.addEventListener('shopify:section:unload', (event) => {
    const slideshows = event.target.querySelectorAll('[data-slideshow]');
    for (const slideshow of slideshows) {
      const blockId = slideshow.dataset.blockId;
      const instance = window.dualTilesSlideshowInstances?.get(blockId);
      if (instance) {
        instance.destroy();
        window.dualTilesSlideshowInstances?.delete(blockId);
      }
    }
  });
}

